import type { CSSProperties } from "react";
import { color, layout, radius, space, typography } from "@tokens/index";

/**
 * Shared style values for the admin pages. Every admin page reads its
 * measures from `layout` and its control chrome from here, so the five
 * pages share one visual vocabulary.
 */

/** Native `<select>` chrome: 40px, `md` radius, hairline border. */
export const adminSelectStyle: CSSProperties = {
    height: `${String(layout.hitArea)}px`,
    width: "100%",
    minWidth: 0,
    paddingInline: space[3],
    borderRadius: radius.md,
    border: `1px solid ${color.border.subtle}`,
    background: color.bg.surface,
    color: color.fg.default,
    fontFamily: typography.family.system,
    fontSize: typography.scale.sm,
    boxSizing: "border-box",
};

/** Column container for a page's content. Centered and capped. */
export function adminPageStyle(maxWidth: number): CSSProperties {
    return {
        width: "100%",
        maxWidth: `${String(maxWidth)}px`,
        marginInline: "auto",
        display: "flex",
        flexDirection: "column",
        gap: space[6],
        minWidth: 0,
    };
}

/** A wrapping row of controls. */
export const controlRowStyle: CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: space[2],
};

/** A text cell that truncates instead of pushing its row wider. */
export const truncatingCellStyle: CSSProperties = {
    minWidth: 0,
    flex: 1,
};
